export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4078d9616986e7e2ee5f6d02c6d7f94a4097f07266&name=revalidateCommunity!'